import filesize from 'filesize';
import { FileManagerRow } from '../../model';

export const SizeCell = (props: { rowData: FileManagerRow }) =>
  props.rowData.size ? filesize(props.rowData.size) : '';
